import React, { createContext, useContext, useState, useCallback } from "react";

export const translations = {
  de: {
    nav: {
      home: "Start",
      performance: "Leistung",
      about: "Über Markus",
      archive: "Archiv",
      pricing: "Mitgliedschaftspläne",
      cta: "Mitglied werden",
      contact: "Kontaktieren",
      admin: "Admin",
    },
    hero: {
      badge: "Verifizierter Premium-Tipster",
      flag: "100 % Österreich",
      eyebrow: "Österreichische Fußball-Intelligenz & Experten-Analyse",
      founderRole: "Gründer & Chef-Analyst",
      bulletDelivery: "Direkte VIP-Zustellung via WhatsApp & Telegram",
      bulletArchive: "Transparente, archivierte Bilanz seit 2005",
      trustWinrate: "Trefferquote",
      trustRoi: "Rendite (ROI)",
      trustYears: "Jahre Erfahrung",
      ctaPrimary: "Jetzt Mitglied werden",
      ctaSecondary: "Gratis-Tagestipp ansehen",
      sinceLabel: "Tipster seit 2005",
      trustTips: "Abgegebene Tipps",
      featured: "Analyse des Tages",
      hit: "AKTIV",
      recentForm: "Aktuelle Form",
      last5: "Letzte 5 Tipps",
      formNote: "Verifizierte Ergebnisse, täglich aktualisiert.",
      tipLabel: "TIPP",
      oddsLabel: "Quote",
    },
    stats: {
      title: "Nachweisbare Leistung",
      subtitle:
        "Jeder Tipp wird transparent dokumentiert. Keine gelöschten Verluste, keine Ausreden – nur belegbare Ergebnisse.",
      winRate: "Trefferquote",
      roi: "Rendite (ROI)",
      totalTips: "Abgegebene Tipps",
      profit: "Gewinn (Einheiten)",
      avgOdds: "Ø Quote",
      members: "Aktive Mitglieder",
      chartTitle: "Gewinnentwicklung 2026 (Einheiten)",
      wins: "Gewonnen",
      losses: "Verloren",
      draws: "Push/Unentschieden",
      won: "Gewonnen",
      lost: "Verloren",
      expertiseTitle: "Spezialgebiete",
      overUnder: "Experte für Über/Unter-Märkte",
      asianHandicap: "Experte für Asian-Handicap-Linien",
      coverage: "Deckt nahezu alle großen Ligen ab",
    },
    method: {
      kicker: "Der Markus-Huber-Vorsprung",
      title: "Präzise Fußball-Tipps, gebaut auf Daten",
      subtitle: "Ich bin Markus Huber. Seit über 20 Jahren mache ich aus disziplinierter Analyse konstante, überprüfbare Fußball-Tipps – spezialisiert auf die Märkte, in denen der echte Value steckt.",
      cards: [
        { tag: "Über / Unter", title: "Über/Unter-Meisterschaft", text: "Total-Tore-Märkte sind mein Zuhause. Ich modelliere Expected Goals, Tempo und defensive Schwächen, um Linien zu finden, die der Markt falsch bepreist – bevor er sich korrigiert." },
        { tag: "Asian Handicap", title: "Asian-Handicap-Präzision", text: "Der AH-Markt belohnt Präzision. Ich lese Linienbewegungen, Team-News und Matchups, um die richtige Seite zur richtigen Quote zu spielen – Viertelpunkt für Viertelpunkt." },
        { tag: "Methode", title: "Datengetriebene Analyse", text: "Keine Bauchentscheidungen. Jeder Tipp durchläuft statistische Modelle, Formkurven, Verletzungen und Live-Marktsignale – Zahlen zuerst, Meinungen danach." },
        { tag: "Bilanz", title: "Bewiesen & Transparent", text: "Ob Gewinn oder Verlust – jeder Tipp wird in meinem öffentlichen Archiv veröffentlicht. Keine gelöschten Verluste, kein Hype, nur ein überprüfbarer Vorsprung." },
      ],
    },
    about: {
      kicker: "Der Experte",
      title: "Markus Huber",
      role: "Fußball-Analyst aus Österreich · 37 Jahre",
      p1: "Seit über 20 Jahren analysiert Markus Huber Fußball auf höchstem Niveau. Markus deckt nahezu alle großen Fußball-Ligen weltweit ab.",
      p2: "Markus setzt auf Disziplin statt Bauchgefühl: statistische Modelle, Team-Form, Verletzungen und Marktbewegungen fließen in jede Empfehlung ein. Kein Hype, keine leeren Versprechen – nur fundierte, langfristig profitable Analysen.",
      quote:
        "„Erfolg im Wetten ist keine Glückssache. Es ist Geduld, Disziplin und ehrliche Daten.“",
      verified: "Verifizierter Premium-Tipster",
      coverage: "Markus deckt nahezu alle großen Fußball-Ligen weltweit ab – nicht nur österreichische, skandinavische und südamerikanische Ligen.",
      features: [
        "Experte für Über/Unter-Märkte",
        "Experte für Asian-Handicap-Linien",
        "Deckt nahezu alle großen Ligen ab",
        "20+ Jahre professionelle Analyse",
      ],
    },
    archive: {
      kicker: "Volle Transparenz",
      title: "Tipp-Archiv",
      subtitle: "Komplette Historie aller abgegebenen Tipps – ungefiltert.",
      searchPlaceholder: "Spiel suchen…",
      allResults: "Alle Ergebnisse",
      allTypes: "Alle Wettarten",
      cols: {
        datetime: "Datum/Zeit",
        tipster: "Tipster",
        match: "Spiel",
        betType: "Wettart",
        tip: "Tipp",
        odds: "Quote",
        score: "Ergebnis",
        result: "Status",
      },
      results: { WIN: "GEWONNEN", LOSS: "VERLOREN", DRAW: "PUSH", "NO TIP": "KEIN TIPP" },
      showing: "angezeigt von",
      empty: "Keine Einträge gefunden.",
      showMore: "Weitere Tipps anzeigen",
    },
    freeTip: {
      kicker: "Gratis-Tipp des Tages",
      title: "Kostenloser Tagestipp",
      subtitle: "Jeden Tag ein handverlesener Gratis-Tipp von Markus Huber – völlig kostenlos.",
      badge: "GRATIS-TIPP",
      today: "Heutiger Gratis-Tipp",
      tipLabel: "Tipp",
      oddLabel: "Quote",
      kickoffLabel: "Anstoß",
      leagueLabel: "Liga",
      analysisLabel: "Markus' Analyse",
      showPrevious: "Frühere Gratis-Tipps ansehen",
      hidePrevious: "Frühere Tipps ausblenden",
      previousTitle: "Frühere Gratis-Tipps",
      empty: "Aktuell kein Gratis-Tipp verfügbar. Schau bald wieder vorbei!",
      results: { PENDING: "LÄUFT", WON: "GEWONNEN", LOST: "VERLOREN", VOID: "VOID" },
    },
    pricing: {
      kicker: "Mitgliedschaft",
      title: "Werde Teil des exklusiven Kreises",
      subtitle:
        "Kein Massenprodukt. Ein limitierter Mitgliederkreis mit direktem Zugang zu Markus' Tipps.",
      popular: "Am beliebtesten & bester Wert",
      perMonth: "",
      choose: "Anfrage senden",
      plans: [
        {
          name: "10 Tipps",
          period: "10 Tipps",
          button: "10 Tipps sichern",
          features: ["Tägliche VIP-Fußballtipps", "Telegram & WhatsApp Alerts", "Over/Under & Handicap Tipps", "24/7 Prioritäts-Support"],
        },
        {
          name: "20 Tipps",
          period: "20 Tipps",
          button: "20 Tipps sichern",
          features: ["Alle 10-Tipps-Vorteile", "Höhere High-Value-Tipps", "Österreich-Liga Deep Dives", "Direkter Experten-Q&A-Zugang"],
        },
        {
          name: "30 Tipps",
          period: "30 Tipps",
          button: "30 Tipps sichern",
          features: ["Voller VIP-Tipps-Pass", "Maximale Quoten & Bankroll-Guide", "Persönliche Einsatz-Strategie", "Voller Archiv-Zugang", "Direkter WhatsApp-Kontakt zu Markus"],
        },
      ],
      form: {
        title: "Mitgliedschaftsanfrage",
        subtitle: "Hinterlasse deine Daten – Markus meldet sich persönlich.",
        name: "Name",
        email: "E-Mail",
        plan: "Gewünschter Plan",
        message: "Nachricht (optional)",
        submit: "Anfrage absenden",
        success: "Danke! Deine Anfrage wurde gesendet. Wir melden uns in Kürze.",
        selectPlan: "Plan auswählen",
      },
    },
    footer: {
      tagline: "Österreichs Premium Fußball-Tipps.",
      disclaimer:
        "18+. Glücksspiel kann süchtig machen. Bitte spiele verantwortungsbewusst. Tipps sind Empfehlungen ohne Gewinngarantie.",
      contact: "Kontakt",
      links: "Navigation",
      legal: "Rechtliches",
      rights: "Alle Rechte vorbehalten.",
      onlyMail: "Kontakt ausschließlich per E-Mail.",
      legalLinks: { terms: "AGB", disclaimer: "Haftungsausschluss", privacy: "Datenschutz", faq: "FAQ" },
      legalContent: {
        terms: { title: "Allgemeine Geschäftsbedingungen", body: "Die auf Austria Tips bereitgestellten Tipps sind unabhängige Einschätzungen und stellen keine Gewinngarantie dar. Mit der Nutzung akzeptieren Sie, dass alle Wettentscheidungen in Ihrer eigenen Verantwortung liegen. Mitgliedschaften sind persönlich und nicht übertragbar. Der Zugang wird nach Bestätigung Ihrer Anfrage per E-Mail bereitgestellt." },
        disclaimer: { title: "Haftungsausschluss", body: "Sportwetten sind mit finanziellen Risiken verbunden. Vergangene Ergebnisse sind keine Garantie für zukünftige Erträge. Austria Tips übernimmt keine Haftung für Verluste, die aus der Nutzung der bereitgestellten Informationen entstehen. Nur für Personen ab 18 Jahren. Spielen Sie verantwortungsbewusst." },
        privacy: { title: "Datenschutzerklärung", body: "Wir verarbeiten Ihre Daten (Name, E-Mail-Adresse) ausschließlich zur Bearbeitung Ihrer Mitgliedschaftsanfrage. Ihre Daten werden nicht an Dritte verkauft oder weitergegeben. Sie können jederzeit die Löschung Ihrer Daten per E-Mail beantragen." },
        faq: { title: "Häufige Fragen (FAQ)", body: "Wie erhalte ich die Tipps? Alle Tipps werden ausschließlich per E-Mail versendet – kein Telegram, kein WhatsApp. Wie viele Tipps pro Tag? In der Regel 1–2 Tipps pro Tag. Gibt es eine Gewinngarantie? Nein – wir liefern fundierte Analysen, aber keine Garantien. Wie werde ich Mitglied? Senden Sie das Anfrageformular ab, Markus meldet sich per E-Mail." },
      },
    },
    contact: {
      kicker: "Kontakt",
      title: "Schreib Markus eine Nachricht",
      subtitle: "Fragen zur Mitgliedschaft oder zu den Tipps? Sende eine Nachricht – Antwort erfolgt per E-Mail.",
      name: "Name",
      email: "E-Mail",
      subject: "Betreff",
      message: "Nachricht",
      submit: "Nachricht senden",
      success: "Danke! Deine Nachricht wurde gesendet.",
      error: "Nachricht konnte nicht gesendet werden. Bitte später erneut versuchen.",
      invalid: "Bitte alle Felder korrekt ausfüllen.",
    },
    admin: {
      loginTitle: "Admin-Anmeldung",
      username: "Benutzername",
      password: "Passwort",
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Verwaltung",
      tabMatches: "Spiele",
      tabSettings: "Inhalte & Statistiken",
      tabLeads: "Anfragen",
      tabFreeTips: "Gratis-Tipps",
      addMatch: "Spiel hinzufügen",
      addFreeTip: "Gratis-Tipp hinzufügen",
      save: "Speichern",
      cancel: "Abbrechen",
      edit: "Bearbeiten",
      delete: "Löschen",
      saved: "Gespeichert",
    },
  },
  en: {
    nav: {
      home: "Home",
      performance: "Performance",
      about: "About Markus",
      archive: "Archive",
      pricing: "Membership Plans",
      cta: "Become a member",
      contact: "Contact Me",
      admin: "Admin",
    },
    hero: {
      badge: "Verified Premium Tipster",
      flag: "100% Austrian",
      eyebrow: "Austrian Football Intel & Expert Analytics",
      founderRole: "Founder & Lead Analyst",
      bulletDelivery: "Direct VIP delivery via WhatsApp & Telegram",
      bulletArchive: "Transparent archived track record since 2005",
      trustWinrate: "Win Rate",
      trustRoi: "Return (ROI)",
      trustYears: "Years of Experience",
      ctaPrimary: "Become a member",
      ctaSecondary: "See the free daily tip",
      sinceLabel: "Tipster since 2005",
      trustTips: "Tips Placed",
      featured: "Analysis of the day",
      hit: "ACTIVE",
      recentForm: "Recent Form",
      last5: "Last 5 tips",
      formNote: "Verified results, updated daily.",
      tipLabel: "TIP",
      oddsLabel: "Odds",
    },
    stats: {
      title: "Proven Performance",
      subtitle:
        "Every tip is documented transparently. No deleted losses, no excuses – just verifiable results.",
      winRate: "Win Rate",
      roi: "Return (ROI)",
      totalTips: "Tips Placed",
      profit: "Profit (Units)",
      avgOdds: "Avg. Odds",
      members: "Active Members",
      chartTitle: "Profit Growth 2026 (Units)",
      wins: "Won",
      losses: "Lost",
      draws: "Push/Draw",
      won: "Won",
      lost: "Lost",
      expertiseTitle: "Areas of Expertise",
      overUnder: "Expert in Under/Over markets",
      asianHandicap: "Expert in Asian Handicap lines",
      coverage: "Covers almost all major leagues",
    },
    method: {
      kicker: "The Markus Huber Edge",
      title: "Precision football tips, built on data",
      subtitle: "I'm Markus Huber. For over 20 years I've turned disciplined analysis into consistent, verifiable football calls — specialising in the markets where the real value hides.",
      cards: [
        { tag: "Over / Under", title: "Over/Under Mastery", text: "Total-goals markets are my home turf. I model expected goals, tempo and defensive fragility to find lines the market misprices — before it corrects." },
        { tag: "Asian Handicap", title: "Asian Handicap Precision", text: "The AH market rewards precision. I read line movement, team news and match-ups to back the right side at the right number, quarter-goal by quarter-goal." },
        { tag: "Method", title: "Data-Driven Analysis", text: "No hunches. Every call runs through statistical models, form curves, injuries and live market signals — numbers first, opinions second." },
        { tag: "Track Record", title: "Proven & Transparent", text: "Win or loss, every tip is published in my public archive. No deleted losses, no hype — just a verifiable, long-term edge." },
      ],
    },
    about: {
      kicker: "The Expert",
      title: "Markus Huber",
      role: "Football Analyst from Austria · Age 37",
      p1: "For over 20 years, Markus Huber has analysed football at the highest level. Markus covers almost all major football leagues worldwide.",
      p2: "Markus relies on discipline over gut feeling: statistical models, team form, injuries and market movements feed into every recommendation. No hype, no empty promises – only solid, long-term profitable analysis.",
      quote:
        "\"Success in betting isn't luck. It's patience, discipline and honest data.\"",
      verified: "Verified Premium Tipster",
      coverage: "Markus covers almost all major football leagues worldwide – not only Austrian, Scandinavian and South American leagues.",
      features: [
        "Expert in Under/Over markets",
        "Expert in Asian Handicap lines",
        "Covers almost all major leagues",
        "20+ years of professional analysis",
      ],
    },
    archive: {
      kicker: "Full Transparency",
      title: "Tip Archive",
      subtitle: "Complete history of all tips placed – unfiltered.",
      searchPlaceholder: "Search match…",
      allResults: "All results",
      allTypes: "All bet types",
      cols: {
        datetime: "Date/Time",
        tipster: "Tipster",
        match: "Match",
        betType: "Bet Type",
        tip: "Tip",
        odds: "Odds",
        score: "Score",
        result: "Result",
      },
      results: { WIN: "WIN", LOSS: "LOSS", DRAW: "PUSH", "NO TIP": "NO TIP" },
      showing: "showing of",
      empty: "No entries found.",
      showMore: "Show more tips",
    },
    freeTip: {
      kicker: "Free Tip of the Day",
      title: "Free Daily Tip",
      subtitle: "A hand-picked free tip from Markus Huber every day – completely free.",
      badge: "FREE TIP",
      today: "Today's Free Tip",
      tipLabel: "Tip",
      oddLabel: "Odds",
      kickoffLabel: "Kickoff",
      leagueLabel: "League",
      analysisLabel: "Markus' Analysis",
      showPrevious: "View previous free tips",
      hidePrevious: "Hide previous tips",
      previousTitle: "Previous Free Tips",
      empty: "No free tip available right now. Check back soon!",
      results: { PENDING: "PENDING", WON: "WON", LOST: "LOST", VOID: "VOID" },
    },
    pricing: {
      kicker: "Membership",
      title: "Join the exclusive circle",
      subtitle:
        "Not a mass product. A limited membership with direct access to Markus' tips.",
      popular: "Most Popular & Best Value",
      perMonth: "",
      choose: "Send inquiry",
      plans: [
        {
          name: "10 Tips",
          period: "10 Tips",
          button: "Get 10 Tips",
          features: ["Daily VIP Match Predictions", "Telegram & WhatsApp Alerts", "Over/Under & Handicap Tips", "24/7 Priority Support"],
        },
        {
          name: "20 Tips",
          period: "20 Tips",
          button: "Get 20 Tips",
          features: ["All 10-Tip Features", "Higher Stake High-Value Tips", "Austrian League Deep Dives", "Direct Expert Q&A Access"],
        },
        {
          name: "30 Tips",
          period: "30 Tips",
          button: "Get 30 Tips",
          features: ["Full VIP Tips Pass", "Maximum Odds & Bankroll Guide", "Personalized Staking Strategy", "Full Archive Access", "Direct WhatsApp from Markus"],
        },
      ],
      form: {
        title: "Membership Inquiry",
        subtitle: "Leave your details – Markus will get back to you personally.",
        name: "Name",
        email: "Email",
        plan: "Preferred plan",
        message: "Message (optional)",
        submit: "Send inquiry",
        success: "Thank you! Your inquiry was sent. We'll be in touch shortly.",
        selectPlan: "Select a plan",
      },
    },
    footer: {
      tagline: "Austria's premium football tips.",
      disclaimer:
        "18+. Gambling can be addictive. Please play responsibly. Tips are recommendations without a guarantee of profit.",
      contact: "Contact",
      links: "Navigation",
      legal: "Legal",
      rights: "All rights reserved.",
      onlyMail: "Contact by email only.",
      legalLinks: { terms: "Terms & Conditions", disclaimer: "Disclaimer", privacy: "Privacy Policy", faq: "FAQ" },
      legalContent: {
        terms: { title: "Terms & Conditions", body: "The tips provided on Austria Tips are independent assessments and do not constitute any guarantee of profit. By using the service you accept that all betting decisions are your own responsibility. Memberships are personal and non-transferable. Access is delivered by email after your inquiry is confirmed." },
        disclaimer: { title: "Disclaimer", body: "Sports betting carries financial risk. Past results are not a guarantee of future returns. Austria Tips accepts no liability for losses arising from the use of the information provided. Strictly 18+. Please gamble responsibly." },
        privacy: { title: "Privacy Policy", body: "We process your data (name, email address) solely to handle your membership inquiry. Your data is never sold or shared with third parties. You may request deletion of your data at any time by email." },
        faq: { title: "Frequently Asked Questions", body: "How do I receive the tips? All tips are sent exclusively by email – no Telegram, no WhatsApp. How many tips per day? Typically 1–2 tips per day. Is there a profit guarantee? No – we provide sound analysis, but no guarantees. How do I become a member? Submit the inquiry form and Markus will contact you by email." },
      },
    },
    contact: {
      kicker: "Contact",
      title: "Send Markus a message",
      subtitle: "Questions about membership or the tips? Send a message – reply comes by email.",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Send message",
      success: "Thanks! Your message has been sent.",
      error: "Message could not be sent. Please try again later.",
      invalid: "Please fill in all fields correctly.",
    },
    admin: {
      loginTitle: "Admin Login",
      username: "Username",
      password: "Password",
      login: "Sign in",
      logout: "Sign out",
      dashboard: "Management",
      tabMatches: "Matches",
      tabSettings: "Content & Stats",
      tabLeads: "Inquiries",
      tabFreeTips: "Free Tips",
      addMatch: "Add match",
      addFreeTip: "Add free tip",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      saved: "Saved",
    },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("at_lang") || "en");

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("at_lang", l);
    document.documentElement.lang = l;
  }, []);

  const toggle = useCallback(() => setLang(lang === "de" ? "en" : "de"), [lang, setLang]);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        cur = cur?.[p];
        if (cur === undefined) return path;
      }
      return cur;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
